import { createQueryKeys } from '@lukemorales/query-key-factory'

import { responseDataTypeName, useFetchSigningSettings } from './useFetchSigningSettings'

export const queryKeys = createQueryKeys(responseDataTypeName, {
  get: ({ workspaceId }: { workspaceId: MaybeRef<string> }) => ({
    queryKey: [workspaceId],
  }),
})

const get = () => {
  const { get } = useFetchSigningSettings()
  const { activeWorkspaceId } = useAuth()

  return useQuery({
    ...queryKeys.get({ workspaceId: activeWorkspaceId as MaybeRef<string> }),
    queryFn: () => get({
      workspaceId: unref(activeWorkspaceId) ?? '',
    }),
    enabled: () => !!unref(activeWorkspaceId),
  })
}

export const useQuerySigningSettings = {
  get,
}
